$(function(){

    $('.js-student-filter').on('keyup', function(){

        // Retrieve the input field text and reset the count to zero
        var filter = $(this).val(),
            count = 0;

        var filter_type;

        if($('.active-courses__students-row')[0]){
            filter_type = '.active-courses__students-row';
        }else if($('.all-students__row')[0]){
            filter_type = '.all-students__row';
        }


        // Loop through the comment list
        $(filter_type).each(function() {


            // If the list item does not contain the text phrase fade it out
            if ($(this).text().search(new RegExp(filter, "i")) < 0) {
                $(this).hide();

                // Show the list item if the phrase matches and increase the count by 1
            } else {
                $(this).show();
                count++;
            }

        });
    })

    $('.js-student-filter-tickets').on('keyup', function(){

        // Retrieve the input field text and reset the count to zero
        var filter = $(this).val(),
            count = 0;

        var filter_type;



        filter_type = '.student-discussions__item';



        // Loop through the comment list
        $(filter_type).each(function() {

            // if($(this).data('status') == 'open'){

                // If the list item does not contain the text phrase fade it out
                if ($(this).data('name').search(new RegExp(filter, "i")) < 0) {
                    $(this).hide();
                    $(this).removeClass('d-flex');
                    // Show the list item if the phrase matches and increase the count by 1
                } else {
                    $(this).addClass('d-flex');
                    count++;
                }
            // }

        });
    })

    var currentPage = 1;
    var previousPage;
    //Custom Pagination All students
    $('.page-numbers').on('click', function(){
        var dataPage = $(this).data('page');
        currentPage = dataPage;

        var dataMax = $('js-pages').data('max');
        $('.page-numbers').removeClass('active-page');
        $('.js-pages').addClass('hide');
        $(this).addClass('active-page');
        $('[data-target="'+ dataPage +'"]').toggleClass('hide');

        if(dataMax == dataPage){
            $('.js-next-page').hide();
        }else{
            console.log((parseFloat(dataPage) + 1));
            $('.js-next-page').show();
            $('.js-next-page').attr('data-page', (parseFloat(dataPage) + 1));
        }



        $('html, body').animate({
            scrollTop: $('.card__account').offset().top
        }, 100);
    })


    //Custom Pagination All students
    $('.js-next-page, .js-prev-page').on('click', function(){

        var dataMax = $(this).data('total');
        $('.page-numbers').removeClass('active-page');
        $('.js-pages').addClass('hide');

        if($(this).hasClass('js-next-page')){
            currentPage++;
            $('.js-prev-page').show();
            $('.js-prev-page').attr('data-page', (parseFloat(currentPage) - 1));
            if((currentPage) == dataMax ){
                $('.js-next-page').hide();
                $('.page-numbers[data-page="'+ currentPage +'"]').addClass('active-page');
                $('.js-pages[data-target="'+ currentPage +'"]').toggleClass('hide');

            }else{
                $('.page-numbers[data-page="'+ currentPage +'"]').removeClass('active-page');
                $('.js-next-page').show();

                $('.js-next-page').attr('data-page', currentPage);
                $('.page-numbers[data-page="'+ currentPage +'"]').addClass('active-page');
                $('.js-pages[data-target="'+ currentPage +'"]').toggleClass('hide');
            }

        }

        if($(this).hasClass('js-prev-page')){
            var prevPage = $(this).attr('data-page');
            previousPage = currentPage--;
            $('.js-next-page').show();
            if(prevPage == 1){

                $('.js-prev-page').hide();
                $('.js-prev-page').attr('data-page', (parseFloat(prevPage) - 1));
                $('.js-pages[data-target="'+ prevPage +'"]').toggleClass('hide');
                $('.page-numbers[data-page="'+ prevPage +'"]').addClass('active-page');
            }else{
                $('.js-prev-page').show();
                $('.js-prev-page').attr('data-page', (parseFloat(prevPage) - 1));
                $('.js-pages[data-target="'+ prevPage +'"]').toggleClass('hide');
                $('.page-numbers[data-page="'+ prevPage +'"]').addClass('active-page');
            }
        }

        $('html, body').animate({
            scrollTop: $('.card__account').offset().top
        }, 100);
    })

    $('.js-social-slide').on('click', function(){
        $(this).toggleClass('crunchify-social--open');
        var $this = this
        $('.social__slider').toggleClass('social__slider--open');
        setTimeout(function(){
            $('h5', $this).toggleClass('open');
        }, 800)
    })

    $('body').delegate('input[type="checkbox"]', 'click', function(){
      $(this).toggleClass('checked');
    })

})